<h1 *ngIf="type === 'h1'" [ngClass]="classes" class="sc-title">{{content}}</h1>
<h2 *ngIf="type === 'h2'" [ngClass]="classes" class="sc-title">{{content}}</h2>
<h3 *ngIf="type === 'h3'" [ngClass]="classes" class="sc-title">{{content}}</h3>